import { usePageGenerationPreviewStreaming } from 'hooks/use-page-generation-preview-streaming';

interface UseMeetingPreviewStreamingOptions {
  meetingId: number;
  streaming?: boolean;
  token?: string;
  channelName?: string;
  previewContent?: unknown;
}

const MEETING_PREVIEW_LOG_CONTEXT = {
  thinkingStreamFailed: 'Meeting preview thinking stream failed',
  htmlFormattingTokensFailed:
    'Failed to fetch HTML formatting tokens for meeting preview',
  postProcessingFailed: 'Meeting preview post-processing failed',
} as const;

export const useMeetingPreviewStreaming = ({
  meetingId,
  streaming = true,
  token,
  channelName,
  previewContent,
}: UseMeetingPreviewStreamingOptions) => {
  return usePageGenerationPreviewStreaming({
    resetKey: meetingId,
    streaming,
    token,
    channelName,
    previewContent,
    shouldFilterByPromptId: true,
    logContext: MEETING_PREVIEW_LOG_CONTEXT,
    step: 'SECTION_PROCESSED',
  });
};
